export default __webpack_public_path__ + "static/media/teachable.c44e4896.png";